@if (bar(); as b) {
  <div class="debt-bar" role="img" [attr.aria-label]="b.label">
    <div class="debt-bar__track">
      @if (b.bands.length) {
        @for (band of b.bands; track band.key) {
          <span
            [class]="'debt-bar__band debt-bar__band--' + band.key"
            [class.debt-bar__band--current]="band.current"
            [style.width.%]="band.width"></span>
        }
        <span
          class="debt-bar__marker"
          [class.debt-bar__marker--overflow]="b.overflow"
          [style.left.%]="b.marker"></span>
      } @else {
        <span
          class="debt-bar__fill"
          [class.debt-bar__fill--critico]="b.level === 'critico'"
          [class.debt-bar__fill--atencao]="b.level === 'atencao'"
          [class.debt-bar__fill--ok]="b.level === 'ok'"
          [style.width.%]="b.marker"></span>
      }
    </div>
    @if (b.legend) {
      <p class="debt-bar__legend">{{ b.legend }}</p>
    }
  </div>
}
